import { createSelector, type Selector } from 'reselect';
import type { AppState } from 'src/reducers';
import { BreadcrumbRestore, CrumbPath } from './Bread.slice';
import { isEmpty, isNil, last } from 'lodash';
import { GroupViewItem } from 'configuration-schemas/viewdefns/general';

interface ActiveViewDefnItems {
  levelBys: GroupViewItem[];
  selectedLevel: GroupViewItem | undefined;
}

const getActiveBreadcrumbKey: Selector<AppState, string | null> = (state) => {
  return state.breadcrumbs.activeBreadcrumbKey;
};

const getCrumbPaths: Selector<AppState, Record<string, CrumbPath[]>> = (state) => {
  return state.breadcrumbs.crumbPaths;
};

const getActiveBreadcrumbRestore: Selector<AppState, BreadcrumbRestore | null> = (state) => {
  return state.breadcrumbs.activeBreadcrumbRestore;
};

interface ActiveViewDefnItemsOutput {
  levelBys: GroupViewItem[];
  selectedLevel: GroupViewItem | undefined;
}
const getActiveViewDefnItems: Selector<AppState, ActiveViewDefnItemsOutput, [ActiveViewDefnItems]> = (
  _state,
  additionalParams,
) => {
  const { levelBys, selectedLevel } = additionalParams;
  return { levelBys, selectedLevel };
};

export const getActiveBreadcrumbs = createSelector(
  getActiveBreadcrumbKey,
  getCrumbPaths,
  (activeBreadcrumbKey, crumbPaths) => {
    return activeBreadcrumbKey ? crumbPaths[activeBreadcrumbKey] : null;
  },
);

export const getActiveBreadcrumb = createSelector(getActiveBreadcrumbs, (activeCrumbPaths) => {
  if (isNil(activeCrumbPaths) || isEmpty(activeCrumbPaths)) {
    return null;
  }
  return last<CrumbPath>(activeCrumbPaths) ?? null;
});

export const maybeRestoreBreadcrumbLevel = createSelector(
  getActiveBreadcrumbRestore,
  getActiveViewDefnItems,
  (restore, { selectedLevel, levelBys }) => {
    return restore?.selectedLevel
      ? (levelBys.find((lb) => lb.dataIndex === restore.selectedLevel) ?? selectedLevel)
      : selectedLevel;
  },
);
